'use client'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useStore } from 'web/src/lib/context/store-context'
import { useCart } from 'medusa-react'
import Button from '../Button'
import Message from '../Message'
import ModelDialog from '../ModelDialog'

const ModelWarning = () => {
    const { cart } = useCart()
    const [showWarning, setShowWarning] = useState<boolean | null>(null)
    const { openModelDialog, allCarModels } = useStore()
    const modelName = allCarModels.find(model => model.handle === cart?.context?.model)
    useEffect(() => {
        if (cart?.created_at) {
            if (!cart?.context?.model) {
                setShowWarning(true)
            } else {
                setShowWarning(false)
            }
        }
    }, [cart])

    return (
        <>
            {showWarning ? (
                <Message color={'red'}>
                    <div className="flex flex-col gap-y-2">
                        <p className="font-medium">Selecteer uw model</p>
                        <p>
                            Je hebt nog geen Mitsubishi model geselecteerd. Selecteer uw Mitsubishi voor de meest
                            relevante zoekresultaten.
                        </p>
                        <Button
                            onClick={openModelDialog}
                            as="button"
                            type="button"
                            variant="primary"
                            className="!w-fit"
                        >
                            Selecteer uw Mitsubishi
                        </Button>
                    </div>
                </Message>
            ) : showWarning === false ? (
                <Message color={'green'}>
                    <div className="flex flex-col gap-y-2">
                        <p className="font-medium">{`Geselecteerd model: ${modelName?.name || ''}`}</p>
                        <p>
                            {`Je hebt het Mitsubishi model ${
                                modelName?.name || ''
                            } geselecteerd, hierop zijn de zoekresultaten gefilterd.`}
                        </p>
                        <Button
                            onClick={openModelDialog}
                            as="button"
                            type="button"
                            variant="primary"
                            className="!w-fit"
                        >
                            Selecteer een ander model
                        </Button>
                    </div>
                </Message>
            ) : null}
            <ModelDialog startClosed />
        </>
    )
}

export default ModelWarning
